import React, { useState } from 'react';
import Button from './Button';
import styles from '../styles/ConfirmButton.module.css';

const ConfirmButton = ({
  onConfirm,
  initialText,
  confirmText,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  className = '',
  ...props
}) => {
  const [needsConfirmation, setNeedsConfirmation] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = () => {
    if (!needsConfirmation) {
      setNeedsConfirmation(true);
      setIsAnimating(true);
      
      // Reset after 3 seconds if not confirmed
      const timer = setTimeout(() => {
        setNeedsConfirmation(false);
        setIsAnimating(false);
      }, 3000);

      return () => clearTimeout(timer);
    } else {
      onConfirm();
      setNeedsConfirmation(false);
      setIsAnimating(false);
    }
  };

  return (
    <div className={styles.confirmButtonWrapper}>
      <Button
        variant={needsConfirmation ? 'error' : variant}
        size={size}
        onClick={handleClick}
        disabled={disabled}
        className={`${className} ${needsConfirmation ? styles.confirm : ''} ${
          isAnimating ? styles.animate : ''
        }`}
        {...props}
      >
        {needsConfirmation ? confirmText : initialText}
      </Button>
    </div>
  );
};

export default ConfirmButton;